export default {
  primary: '#ff5c00',
  secondary: '#ffc5a5',
  grey: '#909090',
};
